export type AddProcurementType = {
  vendor_id: string;
  ingredient_id: string;
  ingredient_name: string;
  vendor_ingredient_id: string;
  vendor_ingredient_price: string;
  vendor_ingredient_unit_type: string;
  quantity: string;
};

export type AddInternalProcurementType = {
  ingredient_id: string;
  ingredient_name: string;
  unit_type: string;
  quantity: string;
  ingredient?: IngredientType | null;
};

export type UpdateProcurementType = {
  vendor_id: string;
  ingredient_id: string;
  id: string;
  ingredient_name: string;
  vendor_name: string;
  anticipated_price: string;
  actual_price: string;
  quantity_requested: string;
  new_quantity_received: string;
  quantity_returned: string;
  vendor_ingredient_price: string;
  vendor_ingredient_unit_type: string;
  quantity: string;
  expiryDate: string;
  invoiceUrls: string[];
};
export type UpdateKitchenProcurementType = {
  vendor_id: string;
  ingredient_id: string;
  id: string;
  ingredient_name: string;
  vendor_name: string;
  anticipated_price: string;
  actual_price: string;
  quantity_requested: string;
  quantity_received: string;
  quantity_sent: string;
  vendor_ingredient_price: string;
  vendor_ingredient_unit_type: string;
  quantity: string;
};

export type UpdateRejectedProcurementType = {
  vendor_id: string;
  ingredient_id: string;
  id: string;
  vendor_ingredient_price: string;
  vendor_ingredient_unit_type: string;
  quantity: string;
};

export enum ENUM_PROCUREMENT_STATUS {
  CREATED = 'CREATED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  RECEIVED = 'RECEIVED',
  COMPLETED = 'COMPLETED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  RETURNED = 'RETURNED',
  REQUESTED = 'REQUESTED',
  REVIEWED = 'REVIEWED',
  CANCELLED = 'CANCELLED',
  SENT = 'SENT',
  OPEN = 'OPEN'
}

export type ProcurementItemType = {
  id: string;
  quantity: string;
  code: number;
  status: ENUM_PROCUREMENT_STATUS;
  price: string;
  ingredient_id: string;
  quantity_returned: string;
  quantity_received: string;
  quantity_sent: string;
  new_quantity_received: string;
  completed: boolean;
  is_complete: boolean;
  actual_price: string;
  vendor: { id: string; name: string };
  ingredient: IngredientType;
  expiryDate: string;
  invoiceUrls: string[];
  quantity_wasted: string;
  excess_quantity: string;
  procurement_request_id: string;
  batches: {
    id: string;
    batch_no: string;
    quantity: string;
  }[];
};

export type IngredientType = {
  id: string;
  name: string;
  category: string;
  unit_weight: string;
  available_quantity: number;
  min_quantity: number;
  min_vendor_price: string;
  created_at: string;
  updated_at: string;
  archived: boolean;
  type: string;
  active: boolean | null;
  unit_type: string;
  shelf_life: number;
  batches: unknown[];
};

export type ProcurementType = {
  code: string | number;
  cokitched_id: string;
  created_at: string;
  updated_at: string;
  id: string;
  cost_of_received_items: string;
  expected_cost: string;
  items: ProcurementItemType[];
  note: string;
  title: string;
  status: ENUM_PROCUREMENT_STATUS;
  quantity_returned?: number;
  request_index?: number;
};

export type KitchenProcurementType = {
  cokitched_id: string;
  id: string;
  items: {
    id: string;
    quantity: string;
    ingredient_id: string;
    quantity_received: string;
    quantity_sent: string;
    kitchen_request_id: string;
    completed: boolean;
    is_complete: boolean;
    ingredient: IngredientType;
  }[];
  status: ENUM_PROCUREMENT_STATUS;
  created_at: string;
  updated_at: string;
  code: number;
};

export type ProcurementParamsType = {
  store_id: string;
  code: string;
  size?: number;
  page: number;
  status?: string | string[];
  start_date?: string;
  end_date?: string;
};
